// Airbnb/Booking.com search deep links — confirmed URL patterns (2026-09), not guessed:
// Airbnb: /s/{slug}/homes?query={query}, Booking.com: /searchresults.html?ss={query}
export function airbnbSearchUrl(town) {
  const slug = `${town.name.replace(/\s+/g, "-")}--${town.state}`;
  const query = encodeURIComponent(`${town.name}, ${town.state}`);
  return `https://www.airbnb.com/s/${slug}/homes?query=${query}`;
}

export function bookingSearchUrl(town) {
  return `https://www.booking.com/searchresults.html?ss=${encodeURIComponent(`${town.name}, ${town.state}`)}`;
}
